import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import routes from '../../routesDefinitions/routes';
import url from '../../constants/config';
import './PlayerNav.scss';

const VISIBILITY_CACHE_KEY = 'playerGuideVisible';

const getAuthHeader = () => ({
  Authorization: `Bearer ${window.localStorage.getItem('authorization')}`,
});

const PlayerNav = () => {
  const [isGuideVisible, setIsGuideVisible] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const cached = window.sessionStorage.getItem(VISIBILITY_CACHE_KEY);
    if (cached === '1') setIsGuideVisible(true);
    if (cached === '0') setIsGuideVisible(false);

    axios
      .get(`${url}/player-portal/info-visibility`, { headers: getAuthHeader() })
      .then(res => {
        const visible = Boolean(res.data?.isVisibleToPlayers);
        if (!isMounted) return;
        setIsGuideVisible(visible);
        window.sessionStorage.setItem(VISIBILITY_CACHE_KEY, visible ? '1' : '0');
      })
      .catch(() => {
        if (!isMounted) return;
        setIsGuideVisible(false);
        window.sessionStorage.setItem(VISIBILITY_CACHE_KEY, '0');
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <nav className="player-nav">
      <NavLink
        exact
        to={routes.playerInbox.link}
        className="player-nav__tab"
        activeClassName="player-nav__tab--active"
      >
        Wiadomości
      </NavLink>
      <NavLink
        exact
        to={routes.playerChecklist.link}
        className="player-nav__tab"
        activeClassName="player-nav__tab--active"
      >
        Mój Plan
      </NavLink>
      {isGuideVisible && (
        <NavLink
          exact
          to={routes.playerInfo.link}
          className="player-nav__tab"
          activeClassName="player-nav__tab--active"
        >
          Przewodnik
        </NavLink>
      )}
    </nav>
  );
};

export default PlayerNav;
